/**
 * The password rule the API enforces at registration, reset and change: at
 * least 8 characters, with an uppercase letter and a number.
 *
 * Checked here before sending so the person reads what is wrong in plain
 * words. The server's own refusal only says "Validation failed.", and the
 * forced-rotation page used to check the length alone, so a password the
 * server would refuse got that bare message.
 */
export const PASSWORD_RULE_HINT = 'At least 8 characters, with an uppercase letter and a number.'

/** What is wrong with a new password, or null when it meets the rule. */
export function passwordRuleProblem(password: string): string | null {
  if (password.length < 8) return 'Your new password needs at least 8 characters.'
  if (!/[A-Z]/.test(password)) return 'Your new password needs an uppercase letter.'
  if (!/[0-9]/.test(password)) return 'Your new password needs a number.'
  return null
}
